import "./skeleton.component.css"

const SkeletonComponent = () => {
  const getEls = () => {
    const numEls = 3 + Math.floor(Math.random() * 5)
    const contentArr = []
    for (let i = 0; i < numEls; i++) {
      const animationDelay = i * 0.1
      contentArr.push(
        <div
          key={i}
          className="cb-page-grid-item cb-skeleton"
          style={{ animationDelay }}
        />
      )
    }

    return contentArr
  }

  return <div className="cb-page-grid">{getEls()}</div>
}

export default SkeletonComponent
